import { Tabs } from "antd";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

import { UserCounterpartyRiskThunk } from "../../Store/Thunks/UserCounterpartyRiskThunk";
import { UserCounterpartyRiskCard } from "../../Components/UserCounterpartyRiskCard";
import DefiShieldCard from "../../Components/DefiShieldCard/DefiShieldCard";
import { UserLightDefiThunk } from "../../Store/Thunks/UserLightDefiThunk";
import { UserLightNFTThunk } from "../../Store/Thunks/UserLightNFTThunk";
import { UserLightDefiCard } from "../../Components/UserLightDefiCard";
import { UserLightNFTCard } from "../../Components/UserLightNFTCard";
import UserAssets from "../../Components/UserAssets";
import ShieldBox from "../../Components/ShieldBox";
import {
  getDefishieldThunk,
  getUserShieldsThunk,
  userShieldThunk,
} from "../../Store/Thunks/UserCardsThunk";
import UserStakingRisk from "../../Components/UserStakingRisk";

export const UserInfo = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { TabPane } = Tabs;
  const loadingTitle = useRef("");

  useEffect(() => {
    if (id) {
      dispatch(getUserShieldsThunk(id));
      dispatch(getDefishieldThunk(id));
    }
  }, [id]);

  const { usersDefiShields, userShieldStates, userShieldSuccess } = useSelector(
    (state) => state.UserCardsReducer,
  );
  const userCounterpartyRiskResult = useSelector((state) => {
    return state.UserCounterpartyRiskReducer.userCounterpartyRiskResult;
  });
  const userLightNTFResult = useSelector((state) => {
    return state.UseLightNTFReducer.userLightNTFResult;
  });
  const useLightDefiResult = useSelector((state) => {
    return state.UseLightDefiReducer.userLightDefiResult;
  });

  const AbleBtn = (type) => {
    loadingTitle.current = type;
    if (id) {
      dispatch(userShieldThunk(+id, type, true));
    }
  };

  const DisableBtn = (type) => {
    loadingTitle.current = type;
    if (id) {
      dispatch(userShieldThunk(+id, type, false));
    }
  };

  useMemo(() => {
    if (userShieldSuccess) {
      dispatch(getUserShieldsThunk(id));
    }
  }, [userShieldSuccess]);

  useEffect(() => {
    dispatch(UserCounterpartyRiskThunk(id));
  }, []);

  useEffect(() => {
    dispatch(UserLightNFTThunk(id));
  }, []);

  useEffect(() => {
    dispatch(UserLightDefiThunk(id));
  }, []);

  return (
    <div className="main_box_right">
      <div className="main_box_right_header">
        <h2 className="user_shield_box_block_text">{state?.name}</h2>
      </div>
      <Tabs defaultActiveKey={"1"} centered>
        <TabPane
          disabled={!userShieldStates?.listingAssets}
          tab={
            <ShieldBox
              AbleBtn={AbleBtn}
              DisableBtn={DisableBtn}
              loadingTitle={loadingTitle}
              title={"Assets Insight"}
              text={"listingAssets"}
            />
          }
          key="1"
        >
          <div className="tab_pane_deFi_shield">
            {userShieldStates?.listingAssets ? (
              <UserAssets userId={id} />
            ) : (
              <span className="no_date_text">No Data</span>
            )}
          </div>
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.stakingRisk}
          tab={
            <ShieldBox
              AbleBtn={AbleBtn}
              DisableBtn={DisableBtn}
              loadingTitle={loadingTitle}
              title={"Staking Risk"}
              text={"stakingRisk"}
            />
          }
          key="2"
        >
          {userShieldStates?.listingAssets ? (
            <UserStakingRisk userId={id} />
          ) : (
            <span className="no_date_text">No Data</span>
          )}
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.deFiShield}
          tab={
            <div className="tab_title_box">
              <ShieldBox
                AbleBtn={AbleBtn}
                DisableBtn={DisableBtn}
                loadingTitle={loadingTitle}
                title={"DeFi Shield"}
                text={"deFiShield"}
              />
            </div>
          }
          key="3"
        >
          <div className="tab_pane_deFi_shield">
            {usersDefiShields?.length ? (
              usersDefiShields.map((item) => (
                <DefiShieldCard key={item.id} item={item} />
              ))
            ) : (
              <span className="no_date_text">No Data</span>
            )}
          </div>
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.lightDeFi}
          tab={
            <div className="tab_title_box">
              <ShieldBox
                AbleBtn={AbleBtn}
                DisableBtn={DisableBtn}
                loadingTitle={loadingTitle}
                title={"Light DeFi"}
                text={"lightDeFi"}
              />
            </div>
          }
          key="4"
        >
          <div className="tab_pane_deFi_shield">
            {useLightDefiResult?.length ? (
              useLightDefiResult.map((item) => (
                <UserLightDefiCard key={item.id} item={item} />
              ))
            ) : (
              <span className="no_date_text">No Data</span>
            )}
          </div>
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.walletShield}
          tab={
            <ShieldBox
              AbleBtn={AbleBtn}
              DisableBtn={DisableBtn}
              loadingTitle={loadingTitle}
              title={"Counterparty Risk"}
              text={"partnersGuard"}
            />
          }
          key="5"
        >
          <div className="tab_pane_deFi_shield">
            {userCounterpartyRiskResult?.length ? (
              userCounterpartyRiskResult.map((item) => (
                <UserCounterpartyRiskCard key={item.id} item={item} />
              ))
            ) : (
              <span className="no_date_text">No Data</span>
            )}
          </div>
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.lightNFT}
          tab={
            <div className="tab_title_box">
              <ShieldBox
                AbleBtn={AbleBtn}
                DisableBtn={DisableBtn}
                loadingTitle={loadingTitle}
                title={"Light NFT"}
                text={"lightNFT"}
              />
            </div>
          }
          key="6"
        >
          <div className="tab_pane_deFi_shield">
            {userLightNTFResult?.length ? (
              userLightNTFResult.map((item) => (
                <UserLightNFTCard key={item.id} item={item} />
              ))
            ) : (
              <span className="no_date_text">No Data</span>
            )}
          </div>
        </TabPane>

        <TabPane
          disabled={!userShieldStates?.walletShield}
          tab={
            <ShieldBox
              AbleBtn={AbleBtn}
              DisableBtn={DisableBtn}
              loadingTitle={loadingTitle}
              title={"Custody Shield"}
              text={"walletShield"}
            />
          }
          key="7"
        >
          <span className="no_date_text">No Data</span>
        </TabPane>
      </Tabs>
    </div>
  );
};
